<template>
  <v-stepper v-model="step" class="elevation-0">
    <v-stepper-header class="elevation-0" alt-labels>
      <v-stepper-step step="1" :complete="step > 1">
        Upload Documents
      </v-stepper-step>
      <v-divider />
      <v-stepper-step step="2">
        Check Comments
      </v-stepper-step>
    </v-stepper-header>
    <v-stepper-items>
      <v-stepper-content class="pa-3" step="1">
        <v-card>
          <v-card-text>
            <div type="file" class="dropzone" @dragover.self="onOver" @drop.prevent.stop.capture="onDrop">
              <div class="file-preview">
                <div
                  v-for="(file, index) in files"
                  v-if="files.length > 0"
                  :key="index"
                  @click="deleteFile(file.name)"
                >
                  <v-chip close color="primary" dark label>
                    {{ file.name }}
                  </v-chip>
                </div>
              </div>
            </div>
            <input type="file" multiple @change="addFiles" />
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn depressed @click="$emit('cancel')">
              Close
            </v-btn>
            <v-btn
              :disabled="files.length === 0"
              :loading="isLoading"
              color="primary"
              depressed
              @click="upload"
            >
              Upload PDF with Comments
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
      <v-stepper-content class="pa-3" step="2">
        <v-card>
          <v-list v-if="importedTasks.length > 0" class="task-list elevation-0" dense two-line>
            <template v-for="(group, key) in grouped">
              <v-subheader :key="key">
                {{ key }}
              </v-subheader>
              <task-list-tile v-for="task in group" :key="task._id" :checkable="false" :task="task" />
            </template>
          </v-list>
          <div v-else class="pa-5 text-md-center">
            No tasks recognized
          </div>
          <v-card-actions>
            <v-btn v-if="importedTasks.length === 0" depressed @click="step = 1">
              Back to Upload
            </v-btn>
            <v-spacer />
            <v-btn depressed @click="$emit('cancel')">
              Close
            </v-btn>
            <v-btn :disabled="!canSubmit" color="primary" depressed @click="setActive">
              Import
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-stepper-content>
    </v-stepper-items>
  </v-stepper>

  <!-- <v-container grid-list-md>
    <v-layout>

    </v-layout>
    <v-layout>
      <div class="dropzone" @dragover.self="onOver" @drop.prevent.stop.capture="onDrop">
        <div class="file-preview">
          <div v-for="(file, index) in files" :key="index"  @click="deleteFile(file.name)">
            <v-chip close>{{ file.name }}</v-chip>
          </div>
        </div>
      </div>
    </v-layout>
    <v-layout>
      <div>

      </div>
    </v-layout>
  </v-container>-->
</template>

<script>
import { IMPORT_TASKS_FROM_PDF, UPDATE_TASK_ACTIVE } from '@/config/constants';
import { mapState } from 'vuex';
// import SlideService from '@/services/modules/slide'
import { groupBy } from 'lodash';
import TaskListTile from '@/components/task-components/subcomponents/task-list-tile';
import { EventBus } from '../../../event-bus';

export default {
  name: 'ImportTasks',
  components: { TaskListTile },
  data() {
    return {
      files: [],
      isLoading: false,
      canSubmit: false,
      step: 1,
      priority: 1
    };
  },
  computed: {
    ...mapState('loop', {
      importedTasks: state => state.tasks.tasksFromPdf.items
    }),
    grouped() {
      return groupBy(this.importedTasks, d => d.slide.name);
    }
  },
  asyncComputed: {
    slideName() {
      return async id => {
        const { SlideService } = require('@/services/modules/slide');
        const slide = await new SlideService().get(id);
        return slide.name;
      };
    }
  },
  methods: {
    onOver: function(e) {
      e.preventDefault();
      e.target.style.background = 'var(--blue)';
      e.target.style.color = 'white';
    },
    onDrop: function(e) {
      e.preventDefault();
      e.target.style.background = 'var(--light-form-bg)';
      e.target.style.color = 'var(--dark)';
      for (let i = 0; i < e.dataTransfer.files.length; i++) {
        if (e.dataTransfer.files[i].type === 'application/pdf') {
          this.files.push(e.dataTransfer.files[i]);
        }
      }
    },
    async setActive() {
      if (this.importedTasks.length > 0) {
        await this.$store.dispatch(UPDATE_TASK_ACTIVE);
        this.$emit('close');
        EventBus.$emit('reload-board', true);
        this.files = [];
        this.step = 1;
        this.isLoading = false;
      }
    },
    addFiles: function(e) {
      for (let i = 0; i < e.target.files.length; i++) {
        if (e.target.files[i].type === 'application/pdf') {
          this.files.push(e.target.files[i]);
        }
      }
    },
    deleteFile: function(file) {
      this.files.splice(
        this.files.findIndex(v => v.name === file),
        1
      );
    },
    upload: function() {
      this.isLoading = true;
      const upload = this.files.map(file => {
        return this.$store.dispatch(IMPORT_TASKS_FROM_PDF, file);
      });

      Promise.all(upload)
        .then(s => {
          if (this.importedTasks.length > 0) {
            this.canSubmit = true;
          }
          this.isLoading = false;
          this.step = 2;
        })
        .catch(e => {
          this.isLoading = false;
        });
    }
  },
  filters: {
    getSlideName: async function(id) {
      const slide = await new SlideService().get(id);
      return slide.name;
    }
  }
};
</script>

<style scoped>
.dropzone {
  width: 100%;
  height: 200px;
  position: relative;
  display: grid;
  background-color: var(--light-form-bg);
  justify-content: center;
  align-items: center;
  border: 5px dashed var(--light-form-bg);
}
.inner-dropzone {
  height: 100%;
  width: 100%;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  margin: 0px auto;
}
.task-list {
  height: 350px;
  overflow: scroll;
  border-radius: 5px;
}
</style>
